import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import { logout } from './auth';

export function clearStateOnLogoutMetaReducer<State>(
  reducer: ActionReducer<State>
): ActionReducer<State> {
  return (state: State | undefined, action: Action): State => {
    if (action.type === logout.type) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer[] = [clearStateOnLogoutMetaReducer];
